module.exports=[
  {
    "specifics": "",
    "highlight": "\"She's very new at this protest thing.\"",
    "svg": "OL-2",
    "final_category": "Offensive language",
    "caption_popup": "An unidentified quotation describing Jane Fonda as \"new to this protest thing\" has sexist overtones that infantilize her and minimize the issues. "
  },
  {
    "specifics": "\"Yesterday's 'invasion' of Fort Lawton by more than 100 Indians and the actress...\"",
    "highlight": "\"invasion\" ",
    "svg": "LI-2",
    "final_category": "Lack of information/underreporting",
    "caption_popup": "It is unclear who is being quoted in the use of the word \"invasion\" in quotes throughout the story. We would identify who used this word and explain if it is an accurate characterization of the demonstration."
  },
  {
    "specifics": "\"It was only a dmonstration with tepee set up\"",
    "highlight": "\"It was only a dmonstration with tepee set up\"",
    "svg": "IL-1",
    "final_category": "Inaccurate language",
    "caption_popup": "Referring to the event as \"only\" a demonstration minimizes the event. "
  },
  {
    "specifics": "Headline: Indian 'attack' on Fort fascinates world press",
    "highlight": "\"'attack'\"",
    "svg": "RL-1",
    "final_category": "Racist language",
    "caption_popup": "The headline uses \"attack,\" playing off the words of an Italian journalist who uses a racist stereotype. It may lead some readers to think the demonstrators were violent, but there is no evidence of this. "
  },
  {
    "specifics": "\"he was assured that frontier war was not imminent",
    "highlight": "\"frontier war\"",
    "svg": "RL-2",
    "final_category": "Racist language",
    "caption_popup": "The use of the phrase \"frontier war\" conjures up the history of the genocide and forced removal of Indigenous people, while using a humorous tone. It is racist and belittling. "
  },
  {
    "specifics": "\"Do you have an Indian problem out there?\"",
    "highlight": "\"Indian problem\"",
    "svg": "RL-3",
    "final_category": "Racist language",
    "caption_popup": "The phrase \"Indian problem\" has a racist history. To repeat it here without context and in an unattributed quotation is offensive."
  },
  {
    "specifics": "\"Indians attacking a fort in the West of the United States!\"",
    "highlight": "\"Indians attacking a fort in the West of the United States!\"",
    "svg": "SF-2",
    "final_category": "Story framing/focus (bias)",
    "caption_popup": "This story mocks international reporters' reactions to the events at Fort Lawton. Its placement on A1 implies that editors thought it was more important than the local news story, on A11. It has no byline or source names, raising questions of credibility."
  }
]